import { render, staticRenderFns } from "./BattleChimpSelect.vue?vue&type=template&id=54feefd6&scoped=true&"
import script from "./BattleChimpSelect.vue?vue&type=script&lang=ts&"
export * from "./BattleChimpSelect.vue?vue&type=script&lang=ts&"
import style0 from "./BattleChimpSelect.vue?vue&type=style&index=0&id=54feefd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54feefd6",
  null
  
)

export default component.exports